

export default [
  {
    path: "/GLkJ6pCq3JsPJOVjDK9t",
    children: [
      {
        path: "",
        component: () => import("@/views/courses/index.vue"),
        name: "course-list",
        meta: {
          authRequired: true,
          title: "Subjects",
          acc: ["y19235"],
        },
      },
      {
        path: "VAq1HyKQKDWJ",
        component: () => import("@/views/courses/assigned.vue"),
        name: "course-assigned",
        meta: {
          authRequired: true,
          title: "Assigned Subjects",
          acc: ["y17236"],
        },
      },
      {
        path: "VAq1HyKQLF",
        component: () => import("@/views/courses/create.vue"),
        name: "create-course",
        meta: {
          authRequired: true,
          title: "Create Subject",
          acc: ["y25935"],
        },
      },
      {
        path: "VAq1HyKCVCF",
        component: () => import("@/views/courses/assign.vue"),
        name: "assign-course",
        meta: {
          authRequired: true,
          title: "Assign Subject",
          acc: ["y47861"],
        },
      },
      {
        path: "ZasDcYLScTfIwJXvdVS1/:cr",
        component: () => import("@/views/courses/view.vue"),
        name: "view-course",
        meta: {
          authRequired: true,
          title:  "View Subject",
          acc: ["y98860"],
        },
      },
      {
        path: "VAq1HyKQLF/:cr",
        component: () => import("@/views/courses/update.vue"),
        name: "update-course",
        meta: {
          authRequired: true,
          title: "Update Subject",
          acc: ["y43784"],
        },
      },
      {
        path: "VAq1HyKQLFbBDZ811TnhQI",
        component: () => import("@/views/courses/upload.vue"),
        name: "upload-course",
        meta: {
          authRequired: true,
          title: "Upload Subject",
          acc: ["y43784"],
        },
      },
    ],
  },
];
